import { DevicesAndStore } from '@lib/mobile-devices-stores';

export function getInstallerAppStoreRedirectUrl(
  hasInstallerCookie: boolean,
  isIOSDevice: boolean,
  isAndroidDevice: boolean,
): string | null {
  if (!hasInstallerCookie) return null;
  if (isIOSDevice) return DevicesAndStore.IPHONE_STORE;
  if (isAndroidDevice) return DevicesAndStore.ANDROID_STORE;
  return null;
}
